/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Why the stream terminated abnormally.
 * @export
 */
export const SearchStreamErrorCode = {
    NotFound: 'not_found',
    Unauthorized: 'unauthorized',
    Timeout: 'timeout',
    Internal: 'internal'
} as const;
export type SearchStreamErrorCode = typeof SearchStreamErrorCode[keyof typeof SearchStreamErrorCode];


export function instanceOfSearchStreamErrorCode(value: any): boolean {
    for (const key in SearchStreamErrorCode) {
        if (Object.prototype.hasOwnProperty.call(SearchStreamErrorCode, key)) {
            if (SearchStreamErrorCode[key as keyof typeof SearchStreamErrorCode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SearchStreamErrorCodeFromJSON(json: any): SearchStreamErrorCode {
    return SearchStreamErrorCodeFromJSONTyped(json, false);
}

export function SearchStreamErrorCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchStreamErrorCode {
    return json as SearchStreamErrorCode;
}

export function SearchStreamErrorCodeToJSON(value?: SearchStreamErrorCode | null): any {
    return value as any;
}

export function SearchStreamErrorCodeToJSONTyped(value: any, ignoreDiscriminator: boolean): SearchStreamErrorCode {
    return value as SearchStreamErrorCode;
}

